import { MdDelete } from "react-icons/md";
import { IoEyeOutline } from "react-icons/io5";
import { MdDragIndicator } from "react-icons/md";
import { useState } from "react";
import downloading from "../HotelCategories/loading.gif";

function ImageCard({ image, isPrimary = false, onDragStart, onDragEnter, onDragEnd, onDragOver, openDeletionModal, openImageViewerModal }) {
    const [isHovered, setIsHovered] = useState(false);

    const styles = {
        wrapper: {
            position: "relative",
            border: "1px solid #E4E4E7",
            borderRadius: "6px",
            overflow: "hidden",
            boxShadow: "0px 1px 4px rgba(0, 0, 0, 0.1)",
            flexDirection: "row",
            userSelect: "none",
            backgroundColor: "white",
            cursor: "move",
        },
        primarySign: {
            position: "absolute",
            top: "8px",
            left: "8px",
            backgroundColor: "var(--mainColor)",
            borderRadius: "6px",
            color: "white",
            padding: "4px 12px",
            fontSize: "14px",
            fontWeight: "500",
        },
        imgContainer: {
            width: "100%",
            height: "200px",
            display: "flex",
            position: "relative",
            justifyContent: "center",
            alignItems: "center",
            backgroundColor: "#f3f4f6",
            borderRadius: "6px 6px 0 0",
            padding: isPrimary ? "1px" : "0",
            img: {
                width: "100%",
                height: "100%",
                objectFit: "cover",
                borderRadius: "6px 6px 0 0",
            },
            hoverItem: {
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                position: "absolute",
                top: "0",
                left: "0",
                width: "100%",
                height: "100%",
                backgroundColor: "rgba(0, 0, 0, 0.4)"
            }
        },
        body: {
            display: "flex",
            justifyContent: "space-between",
            flexDirection: "row",
            padding: "12px",
            actions: {
                display: "flex",
                gap: "8px",
            },
            dragContainer: {
                display: "flex",
                alignItems: "center",
                fontSize: "12px",
                color: "#71717a",
            }
        },
        footer: {
            width: "100%",
            display: isPrimary ? "flex" : "none",
            padding: "8px 12px",
            backgroundColor: "var(--mainColor-light)",
            borderTop: "1px solid #E4E4E7",
            color: "var(--mainColor)",
            fontSize: "14px",
        }
    }

    return (
        <div style={styles.wrapper}
            draggable="true"
            onDragStart={onDragStart}
            onDragEnter={onDragEnter}
            onDragEnd={onDragEnd}
            onDragOver={onDragOver}
        >
            {
                isPrimary && <div style={styles.primarySign}>Primary Image</div>
            }
            <div style={styles.imgContainer} onMouseEnter={() => setIsHovered(true)} onMouseLeave={() => setIsHovered(false)} >
                <img id={`c-${image.uuid}`} src={downloading} alt={image.uuid} style={styles.imgContainer.img} />
                {
                    isHovered && <div style={styles.imgContainer.hoverItem} onMouseLeave={() => setIsHovered(false)}>
                        <div style={{ width: "40px", height: "40px", backgroundColor: "white", borderRadius: "50%", display: "flex", justifyContent: "center", alignItems: "center" }}>
                            <MdDragIndicator style={{ width: "22px", height: "22px", color: "var(--mainColor)" }} />
                        </div>
                    </div>
                }
            </div>
            <div style={styles.body}>
                <div style={styles.body.actions}>
                    {/* <button onClick={openImageViewerModal} className="d-flex align-items-center justify-content-center border rounded p-2">
                        <IoEyeOutline />
                    </button> */}
                    <button onClick={openDeletionModal} className="d-flex align-items-center justify-content-center border rounded p-2">
                        <MdDelete className="text-danger" />
                    </button>
                </div>
                <div style={styles.body.dragContainer}>
                    <MdDragIndicator style={{ width: "18px", height: "18px" }} />
                    Drag to reorder
                </div>
            </div>
            <span style={styles.footer}>
                This image will be displayed prominently to booking users
            </span>
        </div>
    )
}

export default ImageCard;